,
<template>
  <div class="navbar">
    <logo v-if="device !== 'mobile'" />
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container pointer"
      @toggleClick="toggleSideBar"
    />
    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    <!--  -->
    <div class="right-menu">
      <div class="jiaocheng pointer" :class="iswxRobot ? 'right4' : 'right3'" @click="handleCourse">
        <i class="iconfont icon-caozuojiaocheng1" /> 操作教程
      </div>
      <Shipmentrobot
        v-if="iswxRobot"
        :showrobot="true"
        right="480px"
        title="添加智能助理"
        top="11px"
        type="group"
        types="false"
        width="102px"
      />
      <Shipmentdriver
        :show="true"
        down-title="收集司机证件"
        right="370px"
        title="牛卡福司机端"
        :isWrite="isWrite"
        top="11px"
        type="group"
        types="false"
        width="102px"
      />
      <ShipmentFinance
        :show="true"
        down-title="小程序移动支付"
        right="260px"
        title="牛卡福财务端"
        top="11px"
        type="group"
        types="false"
        width="102px"
      />
      <Shipment
        :show="true"
        down-title="移动开单"
        right="150px"
        title="牛卡福货主端"
        :isWrite="isWrite"
        top="11px"
        type="group"
        types="false"
        width="102px"
      />
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper flex">
          <i class="iconfont icon-yonghutouxiang user-avatar font_20 _FFFFFF" />
          <el-tooltip class="item" effect="dark" :content="name" placement="bottom">
            <div class="user-name ellipsis">{{ name }}</div>
          </el-tooltip>
        </div>
        <el-dropdown-menu slot="dropdown" style="width: 120px">
          <el-dropdown-item icon="iconfont icon-xiugai" @click.native="dialogOpen = true"
            >修改密码
          </el-dropdown-item>
          <el-dropdown-item divided icon="iconfont icon-tuichu" @click.native="logout">
            <span>退出登录</span>
          </el-dropdown-item>
          <el-dropdown-item divided disabled>
            <span>牛运宝 V-{{ version }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <nf-confirm
        :show.sync="dialogOpen"
        title="修改密码"
        :append-to-body="true"
        :is-cancel-btn="false"
        :is-savel-btn="false"
        height="300px"
        width="560px"
      >
        <div slot="content" class="get_code">
          <div class="totas">为了保证您的账号安全，变更信息前要验证身份</div>
          <el-form ref="passForm" :model="passForm" :rules="rules" label-position="top">
            <el-form-item label="验证方式：">
              <el-select
                v-model="editType"
                placeholder="请选择"
                style="width: 350px"
                @change="handChangePass(editType)"
              >
                <el-option
                  v-for="item in optionPass"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="editType === 'mobile'" label="验证码：">
              <div class="flexCon">
                <el-col :span="16">
                  <el-input
                    v-model.trim="passForm.code"
                    maxlength="6"
                    placeholder="验证码"
                    @input="handleInput"
                  />
                </el-col>
                <el-col :span="8" class="margin-l-10">
                  <el-button type="text" :disabled="disabled" @click="handGetCode">
                    {{ codeText }}
                  </el-button>
                </el-col>
              </div>
            </el-form-item>
            <el-form-item v-if="editType === 'pass'" label="登录密码：">
              <el-col :span="17">
                <el-input
                  v-model.trim="passForm.pass"
                  :type="passForm.pass ? 'password' : 'text'"
                  maxlength="18"
                  style="width: 350px"
                  placeholder="登录密码"
                  @input="handleInput"
                />
              </el-col>
            </el-form-item>
            <el-form-item label="设置密码：" prop="newpass">
              <el-input
                v-model="passForm.newpass"
                :type="passForm.newpass ? 'password' : 'text'"
                style="width: 350px"
                placeholder="请输入密码"
                autocomplete="off"
                @input="handleInput"
              />
            </el-form-item>
            <el-form-item label="重复密码：" prop="checkPass">
              <el-input
                v-model="passForm.checkPass"
                :type="passForm.checkPass ? 'password' : 'text'"
                style="width: 350px"
                placeholder="请再次输入密码"
                autocomplete="off"
                @input="handleInput"
              />
            </el-form-item>
            <el-form-item class="bottom_box">
              <el-button
                v-throttle="3000"
                @click="passphrasesConfirmed"
                type="primary"
                style="height: 36px; width: 110px; fontsize: 14px; margin-top: 20px"
              >
                提交
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </nf-confirm>
      <!-- <nf-confirm
        :show.sync="dialogPass"
        title="修改密码"
        :append-to-body="true"
        :is-cancel-btn="false"
        :is-savel-btn="false"
        height="300px"
        width="555px"
      >
        <div slot="content" class="get_code">
          <el-form
            ref="upPassForm"
            :model="upPassForm"
            :rules="rules"
            label-position="top"
            label-width="100px"
          >
            <el-form-item label="设置密码：" prop="newpass">
              <el-input
                v-model="upPassForm.newpass"
                type="password"
                style="width: 350px"
                placeholder="请输入密码"
                autocomplete="off"
                @input="handleInput"
              />
            </el-form-item>
            <el-form-item label="重复密码：" prop="checkPass">
              <el-input
                v-model="upPassForm.checkPass"
                type="password"
                style="width: 350px"
                placeholder="请再次输入密码"
                autocomplete="off"
                @input="handleInput"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="height: 36px; width: 110px; fontsize: 14px; margin-top: 20px"
                @click="handleCheckPass"
              >
                提交
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </nf-confirm> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import Logo from './Sidebar/Logo';
import Shipment from '@/components/Shipment/shipment.vue';
import Shipmentdriver from '@/components/Shipment/shipmentdriver.vue';
import Shipmentrobot from '@/components/Shipment/shipmentrobot.vue';
import ShipmentFinance from '@/components/Shipment/shipmentFinance.vue';
import { version } from '@/settings';
import { getGroups, checkAppWhiteList, getPubKey, checkSmartOrder } from '@/api/common';
import { requestSmsCode } from '@/api/login';
import { homeList } from '@/api/home';
import { resetPasswordBySmsCode, resetPasswordByPassword } from '@/api/enterprise';
import JSEncrypt from 'jsencrypt';
import { validatePasswordNew } from '@/utils/rules';

let timer = null;
export default {
  components: {
    Breadcrumb,
    Hamburger,
    Logo,
    Shipment,
    Shipmentrobot,
    Shipmentdriver,
    ShipmentFinance,
  },
  computed: {
    ...mapGetters(['sidebar', 'name', 'device', 'groupConfig']),
  },
  watch: {
    dialogOpen(val) {
      if (val) {
        this.handChangePass('mobile');
      }
    },
    groupConfig(val) {
      if (val && val.wx_robot && val.wx_robot.status) {
        this.iswxRobot = val.wx_robot.status == 1;
      }
    },
  },
  async created() {
    this.getList();
    this.getGroup();
    this.userInfo = window.localStorage.userInfo ? JSON.parse(window.localStorage.userInfo) : {};
  },
  data() {
    const validatePass2 = (rule, value, callback) => {
      if (this.passForm.checkPass == '') {
        callback(new Error('请再次输入密码'));
      } else if (this.passForm.checkPass != this.passForm.newpass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      dialogFormVisible: false,
      dialogOpen: false,
      //   dialogPass: false,
      rules: {
        newpass: [{ validator: validatePasswordNew, trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }],
      },
      version: version,
      editType: 'mobile',
      //   upPassForm: {},
      passForm: {
        code: '',
        pass: '',
        newpass: '',
        checkPass: '',
      },
      codeText: '获取验证码',
      disabled: false,
      time: 60,
      optionPass: [
        {
          value: 'mobile',
          label: '手机号',
        },
        {
          value: 'pass',
          label: '登录密码验证',
        },
      ],
      iswxRobot: false,
      isWrite: false,
    };
  },
  methods: {
    async getList() {
      const { data, code } = await homeList();
      if (code == 200 && data && data.length > 0) {
        // 查找是否有默认项
        let defaultItem = data.find(item => item.isDefault == 1);
        const aicurrentData = data.find(
          item => item.businessId == localStorage.getItem('aicurrentData'),
        );
        const aiBid = data.find(item => item.businessId == localStorage.getItem('aiBid'));
        // 如果没有默认项，将第一条数据设为默认
        if (!defaultItem) {
          defaultItem = data[0];
        }
        if (!aicurrentData) {
          console.log('aicurrentData', defaultItem.businessId);
          localStorage.setItem('aicurrentData', defaultItem.businessId);
        }
        if (!aiBid) {
          localStorage.setItem('aiBid', defaultItem.businessId);
        }
      }
    },
    handleCourse() {
      window.open(
        'https://docs.qq.com/doc/DZkZJVmFEeFBORkNu?u=7711c363f1ce41da8155fb6eb7ab7298',
        '_blank',
        'toolbar=yes',
      );
    },
    //智能录单白名单权限
    async getPermission() {
      const { data } = await checkSmartOrder({
        businessId: window.localStorage.aicurrentData || window.localStorage.aiBid,
      });
      localStorage.setItem('isAiWrite', data.permission);
    },
    async getGroup() {
      const that = this;
      const { code, data } = await getGroups();
      if (code == 200) {
        localStorage.setItem('group', JSON.stringify(data));
        const groups = JSON.parse(localStorage.getItem('group'));
        const res = await checkAppWhiteList({ groupId: groups.id });
        if (res.code == 200) {
          that.isWrite = res.data.whiteList;
        }
        this.getPermission(groups.id);
      }
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    async logout() {
      await this.$store.dispatch('user/logout');
      this.$router.push(`/login`);
    },
    // 修改密码 选择验证方式
    handChangePass(val) {
      this.codeText = '获取验证码';
      this.disabled = false;
      this.editType = val;
      this.passForm.code = '';
      this.passForm.pass = '';
      this.passForm.newpass = '';
      this.passForm.checkPass = '';
    },

    handleInput() {
      this.$forceUpdate();
    },
    // 倒计时
    codeDown() {
      if (timer) {
        clearInterval(timer);
      }
      this.codeText = `${this.time}秒后重新获取`;
      this.disabled = true;
      timer = setInterval(async () => {
        this.codeText = `${--this.time}秒后重新获取`;
        if (this.time <= 0) {
          clearInterval(timer);
          this.time = 60;
          this.codeText = '重新获取验证码';
          this.disabled = false;
        }
      }, 1000);
    },
    // 获取验证码
    async handGetCode() {
      this.codeDown();
      const { data } = await requestSmsCode({
        mobile: this.userInfo.mobile,
        type: 'reset',
      });
      if (data) {
        this.passForm.code = data.code;
      }
    },
    //修改密码  确定按钮
    passphrasesConfirmed() {
      this.$refs['passForm'].validate(async valid => {
        if (valid) {
          // 对内容进行加密
          const encryptor = new JSEncrypt(); // 创建加密对象实例
          const { code, data } = await getPubKey();
          var rsaPassWord = '';
          var rsaPassWordOld = '';
          var pubKeyId = '';
          if (code == 200) {
            pubKeyId = data.pubKeyId;
            encryptor.setPublicKey(data.pubKey);
            rsaPassWord = encryptor.encrypt(this.passForm.newpass);
            if (this.passForm.pass) {
              rsaPassWordOld = encryptor.encrypt(this.passForm.pass);
            }
          }
          console.log('submit!', this.passForm.newpass, rsaPassWord);
          if (this.editType == 'mobile') {
            if (this.passForm.code) {
              resetPasswordBySmsCode({
                newPassword: rsaPassWord,
                code: this.passForm.code,
                pubKeyId: pubKeyId,
              }).then(res => {
                if (res.code == 200) {
                  this.$$message(res.message);
                  setTimeout(() => {
                    this.$store.dispatch('resetToken');
                    this.$router.replace({
                      path: '/login',
                    });
                    this.dialogOpen = false;
                  }, 3000);
                }
              });
            } else {
              this.$$message('验证码不能为空', 'error');
            }
          }
          if (this.editType == 'pass') {
            if (this.passForm.pass) {
              resetPasswordByPassword({
                newPassword: rsaPassWord,
                oldPassword: rsaPassWordOld,
                pubKeyId: pubKeyId,
              }).then(res => {
                if (res.code == 200) {
                  this.$$message(res.message);
                  setTimeout(() => {
                    this.$store.dispatch('resetToken');
                    this.$router.replace({
                      path: '/login',
                    });
                    this.dialogOpen = false;
                    // this.dialogPass = false;
                  }, 3000);
                }
              });
            } else {
              this.$$message('密码不能为空', 'error');
            }
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #14183c;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  z-index: 999;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .jiaocheng {
    position: absolute;
    font-size: 13px;
    line-height: 47px;
    color: #fff;
    .iconfont {
      margin-top: 5px;
    }
    // background: red;
  }
  .right4 {
    right: 590px;
  }
  .right3 {
    right: 480px;
  }
  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 0 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 4px;
        position: relative;
        display: flex;
        width: 100px;
        .user-avatar {
          cursor: pointer;
          width: 20px;
          height: 20px;
          border-radius: 10px;
          line-height: 43px;
        }

        .user-name {
          width: 80px;
          display: inline-block;
          font-size: 14px;
          height: 40px;
          line-height: 40px;
          padding-left: 10px;
          color: #fff;
        }
      }
    }
  }
}
.icon-caozuojiaocheng1 {
  font-size: 12px;
}
.get_code {
  margin-left: 80px;
  .totas {
    width: 336px;
    height: 40px;
    font-size: 16px;
    color: rgba(210, 74, 25, 1);
    line-height: 30px;
    margin-bottom: 10px;
  }
}
</style>
